/**
 * 装载中请求条件
*/
export const LoadQuery = (taskNos, name) => {
  return {
    // title: '发出情况-装载中',route_plan_result
    // dataSource: 'actual_load_unload_result',
    simpleGranularity: 'all',
    dataSource: 'actual_load_unload_result',
    dimensions: ['taskNo', 'deliveryReceiptNo'],
    andFilters: [
      {key: 'scanType', value: '分拨装车'},
      {key: 'scanSite', value: name},
    ],
    inFilters: [
      {key: 'taskNo', value: taskNos},
    ]
  }
}



/**
 * 已发车请求条件
*/
export const DepartureQuery = (taskNos, name) => {
  return {
    // title: '发出情况-已发车',
    simpleGranularity: 'all',
    dataSource: 'actual_load_unload_result',
    dimensions: ['taskNo', 'deliveryReceiptNo'],
    andFilters: [
      {key: 'scanType', value: '分拨装车'},
      // {key: 'taskNo', value: taskNo},
      {key: 'scanSite', value: name},
    ],
    inFilters: [
      {key: 'taskNo', value: taskNos},
    ]
  }
}
// export const DepartureQuery = name => {
//   return [
//     {
//       // title: '发出情况-已发车',
//       dataSource: 'actual_load_unload_result',
//       dimensions: ['taskNo', 'carNo', 'carType', 'nextSite', 'deliveryReceiptNo'],
//       andFilters: [
//         {key: 'scanType', value: '分拨装车'},
//         {key: 'isDestinationCenter', value: '否'},
//         {key: 'scanSite', value: name},
//       ],
//       inFilters: []
//     },
//   ]
// }

/**
 * 运力情况请求条件
*/
export const DeliverSql3 = name => {
  return [
    {
      // title: '运力情况-下一站',
      dataSource: 'actual_load_unload_result',
      dimensions: ['nextSite', 'nextProvinceArea', 'trackLine'],
      andFilters: [
        {key: 'scanType', value: '分拨装车'},
        {key: 'isDestinationCenter', value: '否'},
        {key: 'scanSite', value: name},
      ],
      inFilters: []
    },
    [
      {
        // title: '预测出发  // 预计发中转总计',
        dataSource: 'actual_forecast_result',
        dimensions: ['nextSite', 'nextProvinceArea', 'trackLine'],
        andFilters: [
          {key: 'scanType', value: '分拨发车'},
          {key: 'isDestinationCenter', value: '否'},
          {key: 'scanSite', value: name},
        ]
      },
      {
        // title: '网点预测发中转',
        dataSource: 'actual_forecast_result',
        dimensions: ['nextSite', 'nextProvinceArea', 'trackLine'],
        andFilters: [
          {key: 'scanType', value: '分拨发车'},
          {key: 'isOriginCenter', value: '是'},
          {key: 'isDestinationCenter', value: '否'},
          {key: 'scanSite', value: name},
        ],
        inFilters: []
      },
      {
        // title: '分拨预测发中转',
        dataSource: 'actual_forecast_result',
        dimensions: ['nextSite', 'nextProvinceArea', 'trackLine'],
        andFilters: [
          {key: 'scanType', value: '分拨发车'},
          {key: 'isOriginCenter', value: '否'},
          {key: 'isDestinationCenter', value: '否'},
          {key: 'scanSite', value: name},
        ],
        inFilters: []
      },
      {
        // title: '库存',
        dataSource: 'actual_load_unload_result',
        dimensions: ['nextSite', 'nextProvinceArea', 'trackLine'],
        andFilters: [
          {key: 'scanSite', value: name},
        ],
        inFilters: [
          {key: 'scanType', value: ['分拨卸车', '分拨装车']},
        ]
      },
    ]
  ]
}

/**
 * 派送到达请求条件
 * 通过查找实际发出量 / 预计发出量 后匹配 destinationSite相等
*/
export const DeliverSql4 = name => {
  return [
    {
      // title: '派送到达-预计发出量',
      dataSource: 'route_plan_result',
      dimensions: ['destinationSite'],
      andFilters: [
        {key: 'scanType', value: '分拨发车'},
        {key: 'isDestinationCenter', value: '是'},
        {key: 'scanSite', value: name},
      ],
      inFilters: []
    },
    {
      // title: '派送到达-实际发出量',
      dataSource: 'actual_load_unload_result',
      dimensions: ['destinationSite'],
      andFilters: [
        {key: 'scanType', value: '分拨装车'},
        {key: 'isDestinationCenter', value: '是'},
        {key: 'scanSite', value: name},
      ],
      inFilters: []
    },
  ]
}
